module.exports = __webpack_public_path__ + "img/panya-iso.bd5ff941.png";